import { Pipe, PipeTransform } from '@angular/core';

export interface SuffixNumber {
	value: number,
	symbol: string
}

@Pipe({
	name: 'humanNumber',
	standalone: true
})
export class HumanNumberPipe implements PipeTransform {
	private suffixes: Array<SuffixNumber> = [
		{ value: 1e9, symbol: 'B' },
		{ value: 1e6, symbol: 'M' },
		{ value: 1e3, symbol: 'K' }
	];

	transform(value: number | null | undefined, decimals: number = 1): string {
		if (value === null || value === undefined || isNaN(value)) {
			return '';
		}

		const absValue: number = Math.abs(value);
		
		for (const suffix of this.suffixes) {
			if (absValue >= suffix.value) {
				const num: string = (value / suffix.value).toFixed(decimals);
				return `${parseFloat(num)}${suffix.symbol}`;
			}
		}

		return value.toString();
	}
}

